import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { StylesConfig } from 'react-select';
import AsyncSelect from 'react-select/async';
import { _Object } from 'utils/interfaces';

const AsyncSelectField = forwardRef<HTMLDivElement, _Object>(
  ({ label = '', className, disabled, icon, onBlur, inputValue, onKeyDown, placeholder = 'Choose option', iconSearch, values, defaultOptions, loadOptions, onchange, required = false, error, ...props }, ref) => {
    const customStyles: StylesConfig = {
      control: (provided: Record<string, unknown>) => ({
        ...provided,
        border: error && '1px solid #FF0000',
      }),
    };
    const { t } = useTranslation()

    return (
      <>
        <div className={`form-group mb-3 ${iconSearch ? 'iconSearch' : ''}`} ref={ref}>
          {label && (
            <label className="label-form mb-1">
              {label}
              {required && <span className="text-danger"> *</span>}
            </label>
          )}

          {iconSearch ? (
            <div className="customer-text-search">
              {icon ? <i className={icon}></i> : <i className="fa fa-magnifying-glass"></i>}
            </div>
          ) : null}

          <AsyncSelect
            className={`react-dropdown ${error && 'invalid'}  ${className}`}
            name={'items input_itemx'}
            classNamePrefix="react-select"
            menuPlacement="auto"
            cacheOptions
            value={values}
            onBlur={onBlur}
            inputValue={inputValue}
            isDisabled={disabled}
            onKeyDown={onKeyDown}
            placeholder={placeholder?.length > 0 ? placeholder : t('common.choose_option')}
            defaultOptions={defaultOptions}
            loadOptions={loadOptions}
            onChange={onchange}
            onMenuClose={() => {
              document.getElementById('root')?.click();
            }}
            styles={customStyles}
            {...props}
          />
          {error && <span className="invalid-feedback text-danger d-block mt-1">{error}</span>}
        </div>
      </>
    );
  }
);

AsyncSelectField.displayName = 'AsyncSelectField';

export default AsyncSelectField;

